import type { ActiveBasketSummaryData } from '../../typings/basket.types';
import type { LineItem} from '../../typings/payPal.types';
import { ItemKind, DiscountItemName } from '../../typings/payPal.types';

/**
 * Creates lines items array for payPal request
 */
const createLineItems = (basketSummary: ActiveBasketSummaryData | null): LineItem[] => {
    const lineItems = basketSummary?.items?.map((item) => ({
        name: item.name,
        unitAmount: item.price,
        quantity: item.quantity,
        kind: ItemKind.DEBIT,
    })) ?? [] as LineItem[];

    const promoTotal = basketSummary?.promoTotal ?? 0;

    if (promoTotal !== 0) {
        
        lineItems.push({
            name: DiscountItemName,
            unitAmount: Math.abs(promoTotal),
            quantity: 1,
            kind: ItemKind.CREDIT,
        });
    }

    return lineItems;
};

export default createLineItems;
